/* eslint-disable import/no-unresolved */
import classNames from "classnames";
import Card from "pages/_components/Card/Card";
import CardContainer from "pages/_components/Card/CardContainer";
import DrawerModal from "pages/_components/drawer/DrawerModal";
import Check from "pages/_components/fields/Checkbox";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import InfoTag from "pages/_components/InfoTag";
import { Hint } from "@ui-kit/components/index.es";
import Spinner from "pages/_components/Spinner";
import ReceivedContextMenu from "pages/checks/Echeqs/ReceivedContextMenu";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { actions, selectors } from "reducers/checks";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import {
    checkDisableMultiple,
    echeqShape,
    findEmisor,
    resolveEcheqRowLink,
    shouldShowPendingEcheqSignaturesHint,
    statusTagColor,
} from "util/checks";
import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import { addPrivateShellScrollListener, readPrivateShellScrollTop } from "util/privateShellScrollTarget";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { V3_SCROLL_ROOT_ID } from "v3/constants";

const FORM_ID = "echeq";

class ReceivedEcheqs extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        option: string.isRequired,
        echeqsList: arrayOf(echeqShape).isRequired,
        multipleSelection: bool.isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        selectedRows: arrayOf(echeqShape).isRequired,
        addSelectedRow: func.isRequired,
        selectAll: func.isRequired,
        environmentCuit: string.isRequired,
        setSubmitting: func.isRequired,
        filters: shape({
            createdFrom: string.isRequired,
            createdTo: string.isRequired,
            payedFrom: string.isRequired,
            payedTo: string.isRequired,
            payedCheck: bool.isRequired,
            emitedCheck: bool.isRequired,
            receiver: string.isRequired,
            emitted: string.isRequired,
            status: shape({ value: string.isRequired, label: string.isRequired }).isRequired,
            number: string.isRequired,
            grouper: string.isRequired,
            id: string.isRequired,
            orderColumName: string.isRequired,
            orderDirection: string.isRequired,
        }).isRequired,
        hasMoreData: bool.isRequired,
        fetchNextTransactions: func.isRequired,
        orderByData: func.isRequired,
        currency: string.isRequired,
        accounts: arrayOf(shape({})).isRequired,
        loggedUser: shape({
            userId: string.isRequired,
        }).isRequired,
    };

    state = {
        showDrawer: false,
        contentDrawer: "",
        isAtTop: false,
    };

    componentDidMount() {
        const { filters, orderByData, loggedUser, accounts, dispatch } = this.props;
        orderByData(filters.orderColumName, filters.orderDirection, this.changeFilter);
        this.syncPrivateShellScrollListener();
        if (!accounts.length > 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId, false, "", false));
        }
    }

    componentDidUpdate(prevProps) {
        const { isDesktop } = this.props;
        if (prevProps.isDesktop !== isDesktop) {
            this.syncPrivateShellScrollListener();
        }
    }

    componentWillUnmount() {
        if (this.removePrivateShellScrollListener) {
            this.removePrivateShellScrollListener();
            this.removePrivateShellScrollListener = null;
        }
    }

    syncPrivateShellScrollListener = () => {
        const { isDesktop } = this.props;
        if (this.removePrivateShellScrollListener) {
            this.removePrivateShellScrollListener();
            this.removePrivateShellScrollListener = null;
        }
        if (!isDesktop) {
            this.removePrivateShellScrollListener = addPrivateShellScrollListener(this.handleScrollCheck);
        }
    };

    changeFilter = (filterName, filterDirecion) => {
        const { filters, dispatch, option, setSubmitting, selectAll, isDesktop, currency } = this.props;

        const filtersEcheq = {
            ...filters,
            option,
            status: filters.status,
            orderColumName: filterName,
            orderDirection: filterDirecion,
            pageNumber: 1,
            currency,
        };
        dispatch(actions.setEcheqFilters(filtersEcheq));
        dispatch(actions.setShowCleanFilterButton(true));
        selectAll(false);
        setSubmitting(true);
        dispatch(actions.filterEcheqList(filtersEcheq, setSubmitting, isDesktop));
    };

    cardsReceivedEcheqs = () => {
        const {
            echeqsList,
            multipleSelection,
            addSelectedRow,
            selectedRows,
            environmentCuit,
            isDesktop,
            filters,
        } = this.props;
        const enableRequestRefundData = configUtils.getBoolean("frontend.show.echeqs.request.refund", false);
        const listSorted = echeqsList;
        return listSorted.map((object) => {
            const emisor = findEmisor(object, environmentCuit);
            const receivedDocument = emisor.emisorDocumento.toUpperCase();
            const receivedDocumentNumber = receivedDocument.replace(/\D/g, "");

            return (
                <CardContainer
                    key={object.cheque_id}
                    renderAs={Link}
                    to={resolveEcheqRowLink(object, `/echeqs/received/detail/${object.cheque_id}`)}>
                    {multipleSelection && (
                        <Card
                            checks={
                                multipleSelection && (
                                    <div
                                        className="echeqs__cards-checks"
                                        role="button"
                                        tabIndex={0}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            addSelectedRow(object);
                                        }}
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                            addSelectedRow(object);
                                        }}>
                                        <Check
                                            hideLabel
                                            key={object.cheque_numero}
                                            id={object.cheque_numero}
                                            name={object.cheque_numero}
                                            disabledCheck={checkDisableMultiple(
                                                object,
                                                environmentCuit,
                                                filters.status,
                                            )}
                                            checked={selectedRows.find(
                                                (element) => element.cheque_id === object.cheque_id,
                                            )}
                                            formGroupClassName="mb-0"
                                        />
                                    </div>
                                )
                            }
                            title={
                                <div className="echeqs__cards-title">
                                    <I18n
                                        id={`${FORM_ID}.paymentDate`}
                                        componentProps={{ className: "echeqs__paymentDate" }}
                                    />
                                    <FormattedDate date={object.fecha_pago} />
                                </div>
                            }
                            content={
                                <div className="echeqs__cards-content">
                                    <span className="echeqs__echeqNumber">{object.cheque_numero}</span>
                                    {object.tenencia_beneficiario_documento === environmentCuit && (
                                        <Image src="images/ownershipEcheqs.svg" />
                                    )}
                                    <span className="echeqs__type">{object.cheque_caracter.toUpperCase()}</span>
                                </div>
                            }
                            bottom={
                                <div
                                    className={classNames("echeqs__cards-bottom", {
                                        "flex-flow-wrap": object.cuit_solic_devol,
                                    })}>
                                    <div className="d-flex">
                                        <div className="echeqs__received">
                                            <I18n
                                                id={`${FORM_ID}.received.from`}
                                                componentProps={{ className: "echeqs__received-title" }}
                                            />
                                            <span>{emisor.emisorRazonSocial.replaceAll("#", "Ñ")}</span>
                                        </div>
                                        <I18n
                                            id={`${FORM_ID}.received.from.document`}
                                            componentProps={{ className: "echeqs__received-document" }}
                                        />
                                        <span className="echeqs__received-document-number">
                                            {receivedDocumentNumber}
                                        </span>
                                        {object.cuit_solic_devol && enableRequestRefundData && (
                                            <span className="echeqs__received-title mx-3">|</span>
                                        )}
                                    </div>
                                    {object.cuit_solic_devol && enableRequestRefundData && (
                                        <div className="d-flex flex-flow-nowrap">
                                            <div className="echeqs__received">
                                                <I18n
                                                    id={`${FORM_ID}.return.from`}
                                                    componentProps={{ className: "echeqs__received-title" }}
                                                    defaultValue="Solicitante devolución"
                                                />
                                                <span>{object.solic_devol.replaceAll("#", "Ñ")}</span>
                                            </div>
                                            <I18n
                                                id={`${FORM_ID}.return.from.document`}
                                                componentProps={{ className: "echeqs__received-document" }}
                                                defaultValue="CUIT/CUIL/CDI devolución"
                                            />
                                            <span className="echeqs__received-document-number">
                                                {object.cuit_solic_devol}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            }
                            rightContent={
                                <div className="echeqs__cards-rightContent">
                                    <div className="echeqs__cards-right-info">
                                        {shouldShowPendingEcheqSignaturesHint(object) && (
                                            <div className="echeqs__pending-signatures-hint d-flex justify-content-end w-100">
                                                <Hint
                                                    colorText="dark"
                                                    colorIcon="dark"
                                                    text={i18n.get("echeq.pending.signatures.hint")}
                                                />
                                            </div>
                                        )}
                                        <div className="echeqs__cards-amount">
                                            <FormattedAmount
                                                currency={i18n.get(
                                                    "currency.label.".concat(object.moneda || object.emisor_moneda),
                                                )}
                                                quantity={object.monto}
                                            />
                                        </div>
                                        <div className="d-flex flex-column align-items-end">
                                            <InfoTag
                                                type="info"
                                                message={object.estado}
                                                tagBackground={statusTagColor(object.estado)}
                                                moreStyles={{
                                                    alignSelf: "flex-end",
                                                    width: "fit-content",
                                                    color: "black",
                                                    margin: "auto",
                                                    marginRight: 0,
                                                    whiteSpace: "nowrap",
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="echeqs__context-menu-container">
                                        <ReceivedContextMenu
                                            echeq={object}
                                            isDesktop={isDesktop}
                                            setState={(newState) => this.setState(newState)}
                                        />
                                    </div>
                                </div>
                            }
                            flowFlex
                        />
                    )}
                </CardContainer>
            );
        });
    };

    echeqsListMobile = (echeq) => {
        const { environmentCuit, multipleSelection, addSelectedRow, selectedRows, isDesktop, filters } = this.props;
        const {
            cheque_numero: cheqNro,
            estado,
            monto,
            cheque_caracter: chequeCaracter,
            emisor_moneda: emisorMoneda,
            fecha_pago: fechaPago,
            cheque_id: cheqId,
            solic_devol: returnName,
            cuit_solic_devol: returnDocument,
            moneda,
        } = echeq;
        const enableRequestRefundData = configUtils.getBoolean("frontend.show.echeqs.request.refund", false);
        const emisor = findEmisor(echeq, environmentCuit);
        const { emisorRazonSocial, emisorDocumento } = emisor;

        return (
            <CardContainer
                renderAs={Link}
                to={resolveEcheqRowLink(echeq, `/echeqs/received/detail/${cheqId}`)}
                className="px-3">
                {multipleSelection && (
                    <Card
                        hrClass="echeqs__hr-received"
                        checks={
                            <div
                                className="echeqs__cards-checks"
                                role="button"
                                tabIndex={0}
                                onClick={(e) => {
                                    e.preventDefault();
                                    addSelectedRow(echeq);
                                }}
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                    addSelectedRow(echeq);
                                }}>
                                <Check
                                    hideLabel
                                    key={cheqNro}
                                    id={cheqNro}
                                    name={cheqNro}
                                    disabledCheck={checkDisableMultiple(echeq, environmentCuit, filters.status)}
                                    onChange={() => {
                                        addSelectedRow(echeq);
                                    }}
                                    checked={selectedRows.find((element) => element.cheque_id === cheqId)}
                                />
                            </div>
                        }
                        title={
                            <div className="d-flex w-100 space-between echeqs__cards-title">
                                <div className="d-flex w-100">
                                    <I18n id="echeq.number" componentProps={{ className: "ml-2 echeq__info" }} />
                                    <span className="echeq__data">{cheqNro}</span>
                                </div>
                                <ReceivedContextMenu
                                    echeq={echeq}
                                    isDesktop={isDesktop}
                                    setState={(newState) => this.setState(newState)}
                                />
                            </div>
                        }
                        content={
                            <div>
                                <hr className="ml-2" />
                                <div className="echeqs__cards-content">
                                    <div className="d-flex space-between w-100 pb-1 align-items-center">
                                        <I18n
                                            id="echeqs.status.label"
                                            componentProps={{ className: "ml-2 echeq__info" }}
                                        />
                                        <div className="d-flex flex-column align-items-end">
                                            {shouldShowPendingEcheqSignaturesHint(echeq) && (
                                                <Hint
                                                    colorText="dark"
                                                    colorIcon="dark"
                                                    text={i18n.get("echeq.pending.signatures.hint")}
                                                />
                                            )}
                                            <InfoTag
                                                type="info"
                                                message={estado}
                                                tagBackground={statusTagColor(estado)}
                                                tagClass="d-flex ml-2 my-0 mr-0"
                                                moreStyles={{
                                                    color: "black",
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex space-between w-100">
                                        <I18n
                                            id="echeqs.payedCheck.label"
                                            componentProps={{ className: "ml-2 echeq__info" }}
                                        />
                                        <FormattedDate showTime={false} date={fechaPago} />
                                    </div>
                                    <div className="d-flex space-between w-100 pt-1 align-items-center">
                                        <I18n id="echeq.character" componentProps={{ className: "ml-2 echeq__info" }} />
                                        <span className="echeqs__type">{chequeCaracter}</span>
                                    </div>
                                    <div className="d-flex space-between w-100 pt-1">
                                        <I18n
                                            id={`${FORM_ID}.received.from`}
                                            componentProps={{ className: "ml-2 echeq__info" }}
                                        />
                                        <span className="echeq__data">{emisorRazonSocial.replaceAll("#", "Ñ")}</span>
                                    </div>
                                    <div className="d-flex space-between w-100 pt-1">
                                        <I18n
                                            id="echeqs.document.label"
                                            componentProps={{ className: "ml-2 echeq__info" }}
                                        />
                                        <span className="echeq__data">{emisorDocumento}</span>
                                    </div>
                                    {returnDocument && enableRequestRefundData && (
                                        <>
                                            <div className="d-flex space-between w-100 pt-1">
                                                <I18n
                                                    id={`${FORM_ID}.return.from`}
                                                    componentProps={{ className: "ml-2 echeq__info" }}
                                                    defaultValue="Solicitante devolución"
                                                />
                                                <span className="echeq__data">{returnName.replaceAll("#", "Ñ")}</span>
                                            </div>
                                            <div className="d-flex space-between w-100 pt-1">
                                                <I18n
                                                    id={`${FORM_ID}.return.from.document`}
                                                    componentProps={{ className: "ml-2 echeq__info" }}
                                                    defaultValue="CUIT/CUIL/CDI devolución"
                                                />
                                                <span className="echeq__data">{returnDocument}</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        }
                        rightContent={
                            <div className="echeqs__cards-rightContent">
                                <FormattedAmount
                                    currency={i18n.get("currency.label.".concat(moneda || emisorMoneda))}
                                    quantity={monto}
                                    notBold={isDesktop}
                                    className="echeq__data"
                                />
                            </div>
                        }
                    />
                )}
            </CardContainer>
        );
    };

    handleScrollCheck = () => {
        const scrollTopPosition = readPrivateShellScrollTop();

        // Artificio para evitar recarga de informacion al inicio de la pantalla
        const currentlyAtTop = scrollTopPosition < 5;
        const { isAtTop } = this.state;
        if (currentlyAtTop !== isAtTop) {
            this.setState({ isAtTop: currentlyAtTop });
        }
    };

    render() {
        const { echeqsList, isDesktop, isSmallDesktop, hasMoreData, fetchNextTransactions } = this.props;
        const { showDrawer, contentDrawer, title } = this.state;

        const endOfListItem = (
            <div className="table-row table-end mb-5" key="noMoreTransactions">
                <I18n id="echeqs.noMoreEcheqs" />
            </div>
        );

        const { isAtTop } = this.state;
        if (!isDesktop) {
            return (
                <>
                    <InfiniteScroll
                        dataLength={echeqsList.length}
                        next={() => {
                            if (!isAtTop) {
                                fetchNextTransactions();
                            }
                        }}
                        hasMore={hasMoreData}
                        loader={<Spinner />}
                        initialLoad={false}
                        endMessage={endOfListItem}
                        scrollableTarget={isUxDashboardImprovementsEnabled() ? V3_SCROLL_ROOT_ID : undefined}>
                        {echeqsList.map((echeq) => this.echeqsListMobile(echeq))}
                    </InfiniteScroll>

                    {showDrawer && (
                        <DrawerModal
                            content={contentDrawer}
                            centerContentClassName="mx-5"
                            width={isDesktop ? "30vw" : "100vw"}
                            title={title}
                            isDesktop={isDesktop}
                            showDrawerRemote={showDrawer}
                            closeRemotely={() => this.setState({ showDrawer: false, contentDrawer: "" })}
                            drawerClassName="echeq__drawer"
                        />
                    )}
                </>
            );
        }

        return (
            <div
                className={classNames("flex-grow", {
                    "overflow-visible": !isSmallDesktop,
                    "scrollable pb-2": isSmallDesktop,
                })}>
                <div className="px-4">
                    <Col className="col col-12 px-0">{this.cardsReceivedEcheqs()}</Col>
                    {showDrawer && (
                        <DrawerModal
                            content={contentDrawer}
                            centerContentClassName="mx-5"
                            width={isDesktop ? "30vw" : "100vw"}
                            title={title}
                            isDesktop={isDesktop}
                            showDrawerRemote={showDrawer}
                            closeRemotely={() => this.setState({ showDrawer: false, contentDrawer: "" })}
                            drawerClassName="echeq__drawer"
                        />
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    echeqsList: selectors.getEcheqsList(state),
    environmentCuit: selectors.getEnvironmentCuit(state),
    hasMoreData: selectors.getHasMoreData(state),
    accounts: accountsSelectors.getAccounts(state),
    loggedUser: sessionSelectors.getUser(state),
});

export default connect(mapStateToProps)(ReceivedEcheqs);
